
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/100w-rigid-solar-panel",
      function () {
        return require("private-next-pages/100w-rigid-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/100w-rigid-solar-panel"])
      });
    }
  